import React, { useState, useEffect } from "react";

import { Spinner } from "../utils";
import { ITermOverview, TermOverview } from "./TermOverview";
import { TermDetail, ITermDetail } from "./TermDetail";

import './TermRow.css'

interface IExpendingTermRow {
  overview: ITermOverview;
}

const ExpandingTermRow: React.FC<IExpendingTermRow> = ({ overview }) => {
  const [isSearching, setIsSearching] = useState(false);
  const [result, setResult] = useState<ITermDetail | null>(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (result != null) return;

    setIsSearching(true);
    const url = `_term/${overview.index}`;
    const fetchTerm = async () => {
      const response = await fetch(url);
      const data = await response.json();
      setResult(data);
      setIsSearching(false);
    };
    fetchTerm();
  }, [expanded]);

  return (
    <tr>
      <td>
        <div className="overview-wrapper" onClick={() => setExpanded(!expanded)}>
          <TermOverview {...overview} />
        </div>
        {expanded && (
          <div>
            {isSearching && <Spinner />}
            {result && <TermDetail {...result} />}
          </div>
        )}
      </td>
    </tr>
  );
};

export default ExpandingTermRow;
